module.exports = __webpack_public_path__ + "img/法规类别.8eeb1ae9.png";